// import id from "date-fns/locale/id/index.js";
import { csrfFetch } from "./csrf.js";
import { projectServerUrl } from '../config';

const SET_GPROJECT = 'gproject/setGProject';
const REMOVE_GPROJECT = "gproject/removeGProject";
const SET_GPROJECTS = 'gproject/setGProjects';

const setGProject = (gproject) => ({
  type: SET_GPROJECT,
  payload: gproject,
});

const removeGProject = () => ({
  type: REMOVE_GPROJECT,
});

const setGProjects = (gprojects) => ({
  type: SET_GPROJECTS,
  payload: gprojects,
});

export const create = ({
  id,
  site,
  siteAddress,
  startDate,
  endDate,
  gclientDetails,
  comments,
  doneYN,
  constructionWorkTypeId,
  selectedGlasses,
  selectedSubMaterialProcessItems,
  selectedSubMaterialBuildItems,
  docu04=false,
}) => async dispatch => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects`, {
    method: "POST",
    body: JSON.stringify({
      id,
      site,
      siteAddress,
      startDate,
      endDate,
      gclientDetails,
      comments,
      doneYN,
      constructionWorkTypeId,
      selectedGlasses,
      selectedSubMaterialProcessItems,
      selectedSubMaterialBuildItems,
      docu04,
    }),
  });
  const data = await response.json();

  dispatch(setGProject(data.gproject));

  return response;
};

export const createWithResult = async ({
  id,
  site,
  siteAddress,
  startDate,
  endDate,
  completionDate,
  gclientDetails,
  constructionCompanyName,
  comments,
  doneYN,
  constructionWorkTypeId,
  selectedGlasses,
  selectedSubMaterialProcessItems,
  selectedSubMaterialBuildItems,
  docu04=false,
  gdomesticAuths,
  contractType,
}) => {
  const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects`, {
    method: "POST",
    body: JSON.stringify({
      id,
      site,
      siteAddress,
      startDate,
      endDate,
      completionDate,
      gclientDetails,
      constructionCompanyName,
      comments,
      doneYN,
      constructionWorkTypeId,
      selectedGlasses,
      selectedSubMaterialProcessItems,
      selectedSubMaterialBuildItems,
      docu04,
      gdomesticAuths,
      contractType,
    }),
  });
  const data = await response.json();
  return data;
};

export const modify = ({
  id,
  site,
  siteAddress,
  startDate,
  endDate,
  completionDate,
  gclientDetails,
  constructionCompanyName,
  comments,
  doneYN,
  constructionWorkTypeId,
  selectedGlasses,
  selectedSubMaterialProcessItems,
  selectedSubMaterialBuildItems,
  docu04=false,
  gdomesticAuths,
  contractType,
}) => async dispatch => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects`, {
    method: "PUT",
    body: JSON.stringify({
      id,
      site,
      siteAddress,
      startDate,
      endDate,
      completionDate,
      gclientDetails,
      constructionCompanyName,
      comments,
      doneYN,
      constructionWorkTypeId,
      selectedGlasses,
      selectedSubMaterialProcessItems,
      selectedSubMaterialBuildItems,
      docu04,
      gdomesticAuths,
      contractType,
    }),
  });
  const data = await response.json();

  dispatch(setGProject(data.gproject));

  return response;
};

export const modifyWithResult = async ({
  id,
  site,
  siteAddress,
  startDate,
  endDate,
  completionDate,
  gclientDetails,
  constructionCompanyName,
  comments,
  doneYN,
  constructionWorkTypeId,
  selectedGlasses,
  selectedSubMaterialProcessItems,
  selectedSubMaterialBuildItems,
  docu04=false,
  gdomesticAuths,
  ownerId,
  contractType,
}) => {
  // Wed Dec 07 2022 00:00:00 GMT+0900 (한국 표준시)
  // JSON.stringify하면 2022-12-06T15:00:00.000Z 형태로 바뀜
  const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects`, {
    method: "PUT",
    body: JSON.stringify({
      id,
      site,
      siteAddress,
      startDate,
      endDate,
      completionDate,
      gclientDetails,
      constructionCompanyName,
      comments,
      doneYN,
      constructionWorkTypeId,
      selectedGlasses,
      selectedSubMaterialProcessItems,
      selectedSubMaterialBuildItems,
      docu04,
      gdomesticAuths,
      ownerId,
      contractType,
    }),
  });
  const data = await response.json();
  return data;
};

export const modifyDoneYN = ({ id, doneYN }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects/doneYN`, {
    method: "PUT",
    body: JSON.stringify({ id, doneYN }),
  });
  const data = await response.json();
  dispatch(setGProject(data.gproject));
  return response;
};

export const selectAll = () => async dispatch => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects`);
  const data = await response.json();
  // console.log(data.gprojects)
  dispatch(setGProjects(data.gprojects));
  return response;
}

export const selectAllByOwnerByQuery = (ownerId) => async dispatch => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects/query/selectAll/owner/${ownerId}`);
  const data = await response.json();
  // console.log(data.gprojects)
  dispatch(setGProjects(data.gprojects));
  return response;
}

export const selectAllProjectsOr4docuProjects = (docu04, searchName, searchSite, startDate, endDate, completionDate, page, pageSize) => async dispatch => {
  const params = [];
  if (docu04 !== null && docu04 !== undefined) {
    params.push(`docu04=${docu04}`);
  }
  if (searchName) {
    params.push(`searchName=${searchName}`);
  }
  if (searchSite) {
    params.push(`searchSite=${searchSite}`);
  }
  if (startDate) {
    params.push(`startDate=${startDate}`);
  }
  if (endDate) {
    params.push(`endDate=${endDate}`);
  }
  if (completionDate) {
    params.push(`completionDate=${completionDate}`);
  }
  if (page !== undefined && page !== null && pageSize !== undefined && pageSize !== null) {
    params.push(`page=${page}`);
    params.push(`size=${pageSize}`);
  }

  let querString = params.join("&");

  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects/list${querString ? `?${querString}` : ""}`);
  const data = await response.json(); 
  if (typeof data.totalElements === 'number') {
    dispatch(setGProjects({ gprojects: data.gprojects, count: data.totalElements }));
  } else {
    dispatch(setGProjects(data.gprojects));
  }
  return response;
}

export const selectProjectsOr4docuProjects = (docu04, gclientId, searchName, searchSite, startDate, endDate, completionDate, page, pageSize) => async dispatch => { // TODO : 위의 selectAllByOwnerByQuery와 용어(owner or gclient) 관련 검토
  const params = [];
  if (docu04 !== null && docu04 !== undefined) {
    params.push(`docu04=${docu04}`);
  }
  if (searchName) {
    params.push(`searchName=${searchName}`);
  }
  if (searchSite) {
    params.push(`searchSite=${searchSite}`);
  }
  if (startDate) {
    params.push(`startDate=${startDate}`);
  }
  if (endDate) {
    params.push(`endDate=${endDate}`);
  }
  if (completionDate) {
    params.push(`completionDate=${completionDate}`);
  }
  if (page !== undefined && page !== null && pageSize !== undefined && pageSize !== null) {
    params.push(`page=${page}`);
    params.push(`size=${pageSize}`);
  }

  let querString = params.join("&");

  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects/list/gclient/${gclientId}${querString ? `?${querString}` : ""}`);
  const data = await response.json();
  if (typeof data.totalElements === 'number') {
    dispatch(setGProjects({ gprojects: data.gprojects, count: data.totalElements }));
  } else {
    dispatch(setGProjects(data.gprojects));
  }
  return response;
}

export const select = (id) => async dispatch => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects/${id}`);
  const data = await response.json();
  // console.log(data.gproject)
  dispatch(setGProject(data.gproject));
  return response;
}

export const selectDirect = async (id) => {
  const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects/${id}`);
  const data = await response.json();
  // console.log(data.gproject)
  return data.gproject;
}

export const remove = (id) => async (dispatch) => {
  const response = await csrfFetch(dispatch, `${projectServerUrl}/api/gprojects/${id}`, {
    method: "DELETE",
  });
  dispatch(removeGProject());
  return response;
};

// 대체성적서 선택 정보 수정
export const modifySelectedSubTestDirect = async (gprojectId, selectedSubTest, deleteMode = false) => {
  try {
    // 기존 선택된 대체성적서 목록을 먼저 조회
    const existingData = await selectSelectedSubTestDirect(gprojectId);
    
    let updatedSelectedSubTests = {};
    
    if (existingData && existingData.selectedSubTest && typeof existingData.selectedSubTest === 'object') {
      // 기존 객체가 있으면 복사
      updatedSelectedSubTests = { ...existingData.selectedSubTest };
    }
    
    if (deleteMode) {
      // 삭제 모드: selectedSubTest에 있는 id들을 기존 데이터에서 제거
      if (Array.isArray(selectedSubTest)) {
        selectedSubTest.forEach(item => {
          if (item.id && updatedSelectedSubTests[item.id]) {
            delete updatedSelectedSubTests[item.id];
          }
        });
      } else if (selectedSubTest && selectedSubTest.id) {
        // 단일 객체인 경우
        delete updatedSelectedSubTests[selectedSubTest.id];
      }
    } else {
      // 추가/업데이트 모드 (기존 로직)
      if (Array.isArray(selectedSubTest)) {
        selectedSubTest.forEach(item => {
          if (item.id) {
            // 같은 id가 있으면 업데이트, 없으면 추가
            updatedSelectedSubTests[item.id] = item;
          }
        });
      } else if (selectedSubTest && selectedSubTest.id) {
        // 단일 객체인 경우 - 같은 id가 있으면 업데이트
        updatedSelectedSubTests[selectedSubTest.id] = selectedSubTest;
      }
    }
    
    const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects/selectedSubTest/gprojectId/${gprojectId}`, {
      method: "POST",
      body: JSON.stringify({ 
        gprojectId, 
        selectedSubTest: updatedSelectedSubTests 
      }),
    });
    return response;
  } catch (error) {
    console.error('modifySelectedSubTestDirect error:', error);
    throw error;
  }
}

// 대체성적서 선택 정보 조회
export const selectSelectedSubTestDirect = async (gprojectId) => {
  const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects/selectedSubTest/gprojectId/${gprojectId}`);
  const data = await response.json();
  return data.selectedSubTest;
}

// 대체성적서 선택 정보 삭제
export const deleteSelectedSubTestDirect = async (gprojectId, selectedSubTest) => {
  try {
    // 기존 선택된 대체성적서 목록을 먼저 조회
    const existingData = await selectSelectedSubTestDirect(gprojectId);
    
    let updatedSelectedSubTests = {};
    
    if (existingData && existingData.selectedSubTest && typeof existingData.selectedSubTest === 'object') {
      // 기존 객체가 있으면 복사
      updatedSelectedSubTests = { ...existingData.selectedSubTest };
    }
    
    // selectedSubTest에 있는 id들을 기존 데이터에서 제거
    if (Array.isArray(selectedSubTest)) {
      selectedSubTest.forEach(item => {
        if (item.id && updatedSelectedSubTests[item.id]) {
          delete updatedSelectedSubTests[item.id];
        }
      });
    } else if (selectedSubTest && selectedSubTest.id) {
      // 단일 객체인 경우
      delete updatedSelectedSubTests[selectedSubTest.id];
    }
    
    const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects/selectedSubTest/gprojectId/${gprojectId}`, {
      method: "POST",
      body: JSON.stringify({ 
        gprojectId, 
        selectedSubTest: updatedSelectedSubTests 
      }),
    });
    return response;
  } catch (error) {
    console.error('deleteSelectedSubTestDirect error:', error);
    throw error;
  }
}

export const reorder = async ({ type, id }) => {
  const response = await csrfFetch(null, `${projectServerUrl}/api/gprojects/reorder`, {
    method: "POST",
    body: JSON.stringify({ type, id }),
  });
  
  return response;
}

// 수정 시험성과대비표(시방규격이 있는 경우) 저장
export const createGProjectGTestComparisonDirect = async ({
  gprojectId,
  g04docuGTestId,
  gTestComparisonData,
  useDoc,
  classification
}) => {
  const response = await csrfFetch(null, `${projectServerUrl}/api/gprojectGTestComparisons`, {
    method: "POST",
    body: JSON.stringify({
      gprojectId,
      g04docuGTestId,
      gTestComparisonData,
      useDoc,
      classification
    }),
  });
  
  return response;
}

// 수정 시험성과대비표 수정
export const modifyGProjectGTestComparisonDirect = async ({
  gprojectId,
  g04docuGTestId,
  gTestComparisonData,
  useDoc,
  classification
}) => {
  try {
    const response = await csrfFetch(null, `${projectServerUrl}/api/gprojectGTestComparisons/gprojectId/${gprojectId}/g04docuGTestId/${g04docuGTestId}`, {
      method: "PUT",
      body: JSON.stringify({
        gprojectId,
        g04docuGTestId,
        gTestComparisonData,
        useDoc,
        classification
      }),
    });
    return response;
  } catch (error) {
    console.error('modifyGProjectGTestComparisonDirect error:', error);
    throw error;
  }
}

// 수정 시험성과대비표 존재 여부 확인 (queryString 방식)
export const checkGProjectGTestComparisonExists = async (gprojectId, g04docuGTestId) => {
  try {
    const response = await csrfFetch(null, `${projectServerUrl}/api/gprojectGTestComparisons?gprojectId=${gprojectId}&g04docuGTestId=${g04docuGTestId}`);
    const data = await response.json();
    return data.gprojectGTestComparisons && data.gprojectGTestComparisons.length > 0 ? true : false;
  } catch (error) {
    console.error('checkGProjectGTestComparisonExists error:', error);
    return false;
  }
}

// 프로젝트의 모든 수정 시험성과대비표 목록 조회
export const selectGProjectGTestComparisonsDirect = async (gprojectId = null, g04docuGTestId = null) => {
  try {
    const params = [];
    if (gprojectId) {
      params.push(`gprojectId=${gprojectId}`);
    }
    if (g04docuGTestId) {
      params.push(`g04docuGTestId=${g04docuGTestId}`);
    }

    const queryString = params.join("&");
    const url = `${projectServerUrl}/api/gprojectGTestComparisons${queryString ? `?${queryString}` : ""}`;
    
    const response = await csrfFetch(null, url);
    const data = await response.json();
    return data.gprojectGTestComparisons || [];
  } catch (error) {
    console.error('selectGProjectGTestComparisonsDirect error:', error);
    return [];
  }
}

// 수정 시험성과대비표 삭제
export const removeGProjectGTestComparisonDirect = async (gprojectId, g04docuGTestId) => {
  try {
    const response = await csrfFetch(null, `${projectServerUrl}/api/gprojectGTestComparisons/gprojectId/${gprojectId}/g04docuGTestId/${g04docuGTestId}`, {
      method: "DELETE",
    });
    return response;
  } catch (error) {
    console.error('removeGProjectGTestComparisonDirect error:', error);
    throw error;
  }
}

const initialState = {
  gproject: null,
  gprojects: [],
  count: 0,
};

function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_GPROJECT:
      newState = Object.assign({}, state, { gproject: action.payload });
      return newState;
    case REMOVE_GPROJECT:
      newState = Object.assign({}, state, { gproject: null });
      return newState;
    case SET_GPROJECTS:
      if (Array.isArray(action.payload)) {
        newState = Object.assign({}, state, { gprojects: action.payload });
      } else {
        newState = Object.assign({}, state, {
          gprojects: action.payload.gprojects,
          count: typeof action.payload.count === 'number' ? action.payload.count : state.count,
        });
      }
      return newState;
    default:
      return state;
  }
}

export default reducer;
